<template>
  <unauthorized-layout
    :headerText="headerText"
    :loading="loading"
    :showError="showError"
    :errorHeaderText="errorHeaderText"
  >
    <ui-form v-if="!sent" class="px-8">
      <ui-form-input
        v-model:value="email"
        :labelText="$t('views.passwordReset.inputEmailAddress')"
        id="email"
        type="email"
        :required="true"
      ></ui-form-input>
      <div class="text-center">
        <ui-button @click.stop="send()" color="primary"  type="submit">{{ $t('views.passwordReset.btnContinue') }}</ui-button>
      </div>
      <p class="mt-2 text-sm text-gray-700 dark:text-gray-400 max-w">
        <i18n-t keypath="views.passwordReset.txtHelpText">
          <router-link :to="{ name: 'Login' }" class="underline">{{ $t('views.passwordReset.txtHelpTextLoginHereLink') }}</router-link>
        </i18n-t>
      </p>
    </ui-form>
    <div v-if="sent" class="px-8">
      <p class="mt-2 text-sm text-center text-gray-700 dark:text-gray-400 max-w">
        <i18n-t keypath="views.passwordReset.txtHelpEmailSent1">
          <strong>{{ email }}</strong>
        </i18n-t>
      </p>
      <p class="mt-2 text-sm text-center text-gray-700 dark:text-gray-400 max-w">
        <i18n-t keypath="views.passwordReset.txtHelpEmailSent2">
          <router-link :to="{ name: 'Login' }" class="underline">{{ $t('views.passwordReset.txtHelpEmailSent2LoginLink') }}</router-link>
        </i18n-t>
      </p>
    </div>
  </unauthorized-layout>
</template>

<script>
import uiForm from '@/components/ui/uiForm.vue';
import uiFormInput from '@/components/ui/uiFormInput.vue';
import uiButton from '@/components/ui/uiButton.vue';
import UnauthorizedLayout from '@/components/layouts/UnauthorizedLayout.vue';
import { mapActions } from 'vuex';

export default {
  name: 'PasswordReset',

  components: {
    uiForm,
    uiFormInput,
    uiButton,
    UnauthorizedLayout
  },

  data: function () {
    return {
      email: '',
      sent: false,
      showError: false,
      loading: false,
      headerText: this.$i18n.t('views.passwordReset.headerText'),
      errorHeaderText: ''
    }
  },

  methods: {
    ...mapActions('account', ['passwordResetRequest']),

    send: function() {
      this.showError = false;
      this.loading = true;
      this.passwordResetRequest({email: this.email}).then(() => {
        this.sent = true;
        this.loading = false;
        this.headerText = this.$i18n.t('views.passwordReset.headerTextSent');
      }).catch((error) => {
        if (error.response.status == 400
          && error.response.data.email[0]) {

          this.showError = true;
          this.loading = false;

          if (error.response.data.email[0] == 'This field may not be blank.'
            || error.response.data.email[0] == 'Enter a valid email address.') {
            this.errorHeaderText = this.$i18n.t('views.passwordReset.txtErrEmailInvalid');
          } else {
            this.errorHeaderText = this.$i18n.t('shared.txtUnknownError') + ': ' + JSON.stringify(error.response.data);
          }
        } else {
          this.errorHeaderText = this.$i18n.t('shared.txtUnknownError') + ': ' + JSON.stringify(error.response.data);
        }
      });
    }
  }
}
</script>
